import { render, staticRenderFns } from "./CadastroFornecedor.vue?vue&type=template&id=671db1cc"
import script from "./CadastroFornecedor.vue?vue&type=script&lang=js"
export * from "./CadastroFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports